import { createFileRoute } from "@tanstack/react-router";
import { AdvancedScenarios } from "@/pages/3d/examples/AdvancedScenarios";

export const Route = createFileRoute("/demo/3d/examples/advanced")({
  component: AdvancedScenarios,
});
